up.compiler('#notes', function() {
  function checkPaneView() {
    var $body = $(document.body);
    var paneView = !!up.fragment.get('.pane_view');
    $body.toggleClass('without_tail', paneView);
  }

  checkPaneView();
  return checkPaneView;
});
